export * from './recurrenceeditor.component';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-react-schedule/src/recurrence-editor/index.js
// module id = 1969
// module chunks = 0